( () => {
	const navToggle = document.querySelector( '.wp-block-phrase-com-nav-toggle' );
	const toggleOpen = navToggle?.querySelector( '.wp-block-phrase-com-nav-toggle__button--open' );
	const toggleClose = navToggle?.querySelector(
		'.wp-block-phrase-com-nav-toggle__button--close'
	);
	const siteMenu = document.querySelector( '.site-menu' );
	if ( ! navToggle || ! toggleOpen || ! toggleClose || ! siteMenu ) {
		return;
	}

	// Enhance site menu with id.
	siteMenu.id = 'site-menu';

	// Replace toggle buttons with span elements.
	const spanOpen = document.createElement( 'span' );
	spanOpen.className = toggleOpen.className;
	spanOpen.innerHTML = toggleOpen.innerHTML;
	spanOpen.setAttribute( 'aria-label', toggleOpen.getAttribute( 'aria-label' ) ?? '' );
	toggleOpen.replaceWith( spanOpen );

	const spanClose = document.createElement( 'span' );
	spanClose.className = toggleClose.className;
	spanClose.innerHTML = toggleClose.innerHTML;
	spanClose.setAttribute( 'aria-label', toggleClose.getAttribute( 'aria-label' ) ?? '' );
	toggleClose.replaceWith( spanClose );

	// Replace navToggle div with a button element.
	const navToggleButton = document.createElement( 'button' );
	navToggleButton.className = navToggle.className;
	navToggleButton.setAttribute( 'aria-expanded', 'false' );
	navToggleButton.setAttribute( 'aria-controls', 'site-menu' );
	navToggleButton.append( spanOpen );
	navToggleButton.append( spanClose );
	navToggle.replaceWith( navToggleButton );

	navToggleButton.addEventListener( 'click', () => {
		navToggleButton.setAttribute(
			'aria-expanded',
			'true' === navToggleButton.getAttribute( 'aria-expanded' ) ? 'false' : 'true'
		);
	} );
} )();
